import React, { Component } from "react";
import DeleteDialog from "../../components/DeleteDialog";
import { languages } from "../../constants/languages";
import MenuItem from "@material-ui/core/MenuItem";

class DeleteFieldContainer extends Component {
  state = {
    open: false,
    errorMessage: "",
    confirmationShown: false,
  };

  toggleDialog = () => {
    if (this.state.open && this.props.handleMenuClose) {
      this.props.handleMenuClose();
    }
    this.setState({ open: !this.state.open });
  };

  handleConfirmation = () => {
    this.setState({
      errorMessage: languages.schedule.confirmDeleteField,
      confirmationShown: true,
    });
  };

  handleDelete = () => {
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("matches")
      .where("field", "==", this.props.field.id)
      .get()
      .then((querySnapshot) => {
        const db = window.firebase.firestore();
        let batch = db.batch();
        const matchesRef = db
          .collection("tournaments")
          .doc(this.props.tournament[".key"])
          .collection("matches");

        querySnapshot.forEach(function (doc) {
          batch.update(matchesRef.doc(doc.id), {
            field: null,
            day: "0",
            referee: "",
            referee2: "",
            referee3: "",
            referee4: "",
            referee5: "",
            st: "",
            et: "",
            duration: null,
          });
        });

        let breaks = this.props.tournament.breaks || {};
        let matchBreaks = this.props.matches.filter(
          (m) => m.isBreak && m.field === this.props.field.id
        );
        for (let b in matchBreaks) {
          delete breaks[matchBreaks[b].id];
        }

        // delete field
        let newFields = this.props.tournament.fields;
        delete newFields[this.props.field.id];

        batch.update(
          db.collection("tournaments").doc(this.props.tournament[".key"]),
          { fields: newFields, breaks: breaks }
        );
        if (this.props.tournament.ia) {
          batch.set(db.collection("cacheUpdatesApp").doc(), {
            tournamentId: this.props.tournament[".key"],
            status: "pending",
            timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
          });
        }
        batch.commit();
        this.toggleDialog();
      });
  };

  render() {
    return (
      <div>
        <MenuItem onClick={this.toggleDialog}>
          {languages.schedule.deleteField}
        </MenuItem>
        <DeleteDialog
          open={this.state.open}
          toggleDialog={this.toggleDialog}
          handleDelete={
            this.props.days.length > 0
              ? this.state.confirmationShown
                ? this.handleDelete
                : this.handleConfirmation
              : this.handleDelete
          }
          confirmationShown={this.state.confirmationShown}
          errorMessage={this.state.errorMessage}
          title={languages.schedule.deleteField}
          description={
            this.props.matches.length > 0
              ? languages.schedule.deleteFieldWarning +
                " " +
                languages.schedule.deleteFieldWarning2
              : languages.schedule.deleteFieldWarning
          }
        />
      </div>
    );
  }
}

export default DeleteFieldContainer;
